// packages/react/use-callback-ref/src/use-callback-ref.tsx
import * as React from "react";
function useCallbackRef(callback) {
  var callbackRef = React.useRef(callback);
  React.useEffect(function () {
    callbackRef.current = callback;
  });
  return React.useMemo(function () {
    return function () {
      var _callbackRef$current;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call.apply(_callbackRef$current, [callbackRef].concat(args));
    };
  }, []);
}
export { useCallbackRef };